/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for A+ Content Management
 * Use the A+ Content API to build applications that help selling partners add rich marketing content to their Amazon product detail pages. Selling partners can use A+ content to share their brand and product story, which helps buyers make informed purchasing decisions. Selling partners use content modules to add images and text.
 *
 * The version of the OpenAPI document: 2020-11-01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The type of rich text decorator.
 */

export const DecoratorType = {
    ListItem: 'LIST_ITEM',
    ListOrdered: 'LIST_ORDERED',
    ListUnordered: 'LIST_UNORDERED',
    StyleBold: 'STYLE_BOLD',
    StyleItalic: 'STYLE_ITALIC',
    StyleLinebreak: 'STYLE_LINEBREAK',
    StyleParagraph: 'STYLE_PARAGRAPH',
    StyleUnderline: 'STYLE_UNDERLINE',
} as const;

export type DecoratorType = typeof DecoratorType[keyof typeof DecoratorType];



